const mediaQuery = window.matchMedia("(min-width: 768px)");

function textDoBigThings() {
  const right = document.querySelector(".right");
  const left = document.querySelector(".left");
  const containerText = document.querySelector(".animation-text-container");

  if (right && left && containerText) {
    gsap.set(right, {
      x: mediaQuery.matches ? -600 : 500,
    });

    gsap.set(left, {
      x: mediaQuery.matches ? 600 : -600,
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: containerText,
        start: "top 70%",
        end: "bottom 70%",
        scrub: 3,
      },
    });

    tl.to(
      right,
      {
        x: mediaQuery.matches ? 0 : 285,
        ease: "power10.inOut",
      },
      "b",
    );

    tl.to(
      left,
      {
        x: mediaQuery.matches ? 0 : -278,
        ease: "power10.inOut",
      },
      "b",
    );
  }
}

export default textDoBigThings;
